// Chart.js registration and shared options for the Quant Screener (registration is idempotent).
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Filler, Tooltip, Legend,
} from 'chart.js';
import { NAVY, TEAL, SLATE, TEAL_DARK, SAGE, MAUVE, LIGHT_BLUE } from './palette';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Filler, Tooltip, Legend);

export const SERIES_COLOURS = [NAVY, TEAL, MAUVE, TEAL_DARK, SLATE, '#7F7F7F', SAGE, '#599BE3', '#FBAE40', LIGHT_BLUE];
export const seriesColour = (i) => SERIES_COLOURS[i % SERIES_COLOURS.length];

export const baseLineOptions = (unit, title) => ({
  responsive: true, maintainAspectRatio: false, animation: false,
  interaction: { mode: 'index', intersect: false },
  elements: { point: { radius: 0, hitRadius: 6 }, line: { borderWidth: 1.6, tension: 0.1 } },
  scales: {
    x: { ticks: { maxTicksLimit: 12, font: { size: 10 }, color: '#7F7F7F' }, grid: { display: false } },
    y: { ticks: { font: { size: 10 }, color: '#7F7F7F', callback: (v) => (unit === 'pct' ? `${(v * 100).toFixed(1)}%` : Number(v).toFixed(2)) },
      grid: { color: '#EEF1F4' }, title: title ? { display: true, text: title, font: { size: 10 }, color: '#3F4A59' } : undefined },
  },
  plugins: {
    legend: { position: 'bottom', labels: { boxWidth: 10, font: { size: 10 }, usePointStyle: true } },
    tooltip: { callbacks: { label: (c) => `${c.dataset.label}: ${c.parsed.y === null ? '–' : unit === 'pct' ? `${(c.parsed.y * 100).toFixed(2)}%` : c.parsed.y.toFixed(3)}` } },
  },
});

export const shortDate = (iso) => {
  const [y, m] = String(iso).split('-');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[Number(m) - 1] || m} ${String(y).slice(2)}`;
};
